/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import ReactInputMask from 'react-input-mask';
import { InputStyles } from './InputStyles';

const Input = props => {
  const {
    type,
    name,
    label,
    className,
    placeholder,
    customClass,
    mask = null,
    required = false,
    onKeyUpAction = false,
    showAsterisk = true,
    ...rest
  } = props;

  return (
    <Field name={name}>
      {({ field, form, meta }) => {
        const hasError = form.submitCount > 0 && meta.touched && meta.error;
        return (
          <InputStyles className={['field-wrap', className].join(' ')}>
            <label htmlFor={name} className={field.value ? 'is-raised' : ''}>
              <span className="label-text">
                {label} {showAsterisk && required  && '*'}
              </span>
              <ReactInputMask
                type={type || 'text'}
                id={name}
                name={name}
                mask={mask}
                maskChar={null}
                placeholder={placeholder}
                className={`${customClass || ''} ${['field-control', hasError ? 'has-error' : null].join(' ')}`}
                onKeyUp={onKeyUpAction ? onKeyUpAction : undefined}
                {...field}
                {...rest}


              />
            </label>
            {hasError && <div className="error-message text-left">{meta?.error || 'Required'}</div>}
          </InputStyles>
        );
      }}
    </Field>
  );
};

Input.propTypes = {
  type: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
};

export default Input;
